import React from 'react';
import { Dialog, DialogContent, DialogFooter } from './dialog';
import { Button } from './button';

interface AlertModalProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

/** Drop-in replacement for `window.alert(message)` — same single-button
 * "OK" acknowledgement, just as an in-app modal instead of a native dialog. */
export const AlertModal: React.FC<AlertModalProps> = ({ isOpen, message, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <p className="text-sm text-ink-secondary whitespace-pre-line">{message}</p>
        <DialogFooter>
          <Button type="button" variant="primary" onClick={onClose}>
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
